import { Pipe, PipeTransform } from '@angular/core';
import { catchError, map, of, Observable } from 'rxjs';
import { TranslationHelperService } from '../services/translations/translation-helper.service';

@Pipe({
  standalone: true,
  name: 'label'
})
export class LabelPipe implements PipeTransform {
  constructor(
    private translationHelper: TranslationHelperService,
  ) {}

  transform(value: any, prefix: string = 'labels.'): Observable<any> {
    const key = (prefix !== null ? prefix : '') + value;

    return this.translationHelper.get(key).pipe(
      map((translation) => (translation === key) ? value : translation),
      catchError(() => of(value))
    );
  }
}
